import { render, staticRenderFns } from "./tagComponent.vue?vue&type=template&id=09689192&scoped=true"
import script from "./tagComponent.vue?vue&type=script&lang=js"
export * from "./tagComponent.vue?vue&type=script&lang=js"
import style0 from "./tagComponent.vue?vue&type=style&index=0&id=09689192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09689192",
  null
  
)

export default component.exports